<template>
    <div id="logo" class="flex justify-center">
        <img
            src="@/assets/images/logo.png"
            class="wellful-logo-img mt-3 mb-3 sm:mb-12 sm:mt-12"
            alt="Wellful Logo"
        />
    </div>
</template>

<script>
export default {
    name: 'wellful-logo'
}
</script>

<style scoped>
#logo {
    background-color: #b7dcc9;
}
.wellful-logo-img {
    max-height: 70px;
    max-width: 100%;
}
</style>
